import React, { useState, useEffect } from 'react'
import InputMask from 'react-input-mask'
import { getPhoneMask } from 'components'
import { TextField } from '@mui/material'
import { type Phone } from 'services'

interface PhoneTextFieldProps {
  label: string
  filterKey: keyof Phone
  value: string
  disabled: boolean
  handlePhoneChange: (e: React.ChangeEvent<HTMLInputElement>, filterKey: keyof Phone) => void
  countryDesc: string | null
}

export const PhoneTextField: React.FC<PhoneTextFieldProps> = ({ label, filterKey, value, disabled, handlePhoneChange, countryDesc }) => {
  const [disabledPhone, setDisabledPhone] = useState(disabled)

  useEffect(() => {
    if (countryDesc == null) {
      setDisabledPhone(true)
    } else {
      setDisabledPhone(disabled)
    }
  }, [countryDesc, disabled])

  return (
        <div>
            <InputMask
                mask={getPhoneMask(countryDesc ?? '')}
                value={value}
                onChange={(e) => { handlePhoneChange(e, filterKey) }}
                disabled={disabledPhone}
            >
                <TextField
                    id="outlined-basic"
                    label={label}
                    variant="outlined"
                    disabled={disabledPhone}
                    fullWidth
                    helperText={disabledPhone ? 'Please choose a country first' : ''}
                />
            </InputMask>
        </div>
  )
}
